import React, { useState } from "react"
import parse from "html-react-parser"
import { useSiteTranslations } from "@hooks/useSiteTranslations"
import * as s from "./ProductDescription.module.scss"

export const Tabbed = ({ productDescription }) => {
  const [tab, setTab] = useState(0)
  const {
    shopTranslations: { shop },
  } = useSiteTranslations()

  return (
    <div className={s.Tabbed}>
      <div className={s.Tabbed__header}>
        <div
          onClick={() => {
            setTab(0)
          }}
          className={`${s.Tabbed__tabTitle} ${
            tab == 0 && s.Tabbed__tabTitle___active
          }`}
        >
          <i className="fas fa-beer"></i>
          <span>{shop.tabbedArea.tabOneTitle}</span>
        </div>
        <div
          onClick={() => {
            setTab(1)
          }}
          className={`${s.Tabbed__tabTitle} ${
            tab == 1 && s.Tabbed__tabTitle___active
          }`}
        >
          <i className="fa-solid fa-truck-ramp-box"></i>
          <span>{shop.tabbedArea.tabTwoTitle}</span>
        </div>
      </div>

      <div
        className={s.Tabbed__tab}
        style={tab == 0 ? { display: "block" } : {}}
      >
        {parse(productDescription)}
      </div>
      <div
        className={s.Tabbed__tab}
        style={tab == 1 ? { display: "block" } : {}}
      >
        {parse(shop.tabbedArea.tabTwoContent, {
          replace: ({ name }) => name === "br" && <></>,
        })}
      </div>
    </div>
  )
}
